import { cn } from "@/utils";
import { forwardRef, TextareaHTMLAttributes } from "react";

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, ...props }: TextAreaProps, ref) => (
    <textarea
      ref={ref}
      className={cn(
        "p2-medium rounded-lg bg-surface-secondary px-3 py-[10px] text-item-primary transition-colors duration-100 placeholder:text-item-secondary",
        "hover:bg-surface-tertiary",
        "focus:text-item-primary focus:outline focus:outline-1 focus:outline-border-active",
        "disabled:cursor-not-allowed disabled:text-item-tertiary disabled:placeholder:text-item-tertiary disabled:hover:bg-surface-secondary",
        className,
      )}
      {...props}
    />
  ),
);

TextArea.displayName = "TextArea";
